import React, { useEffect, useState, useContext } from "react";
import { Context } from "../auth_components/state/Store";
import "./LoginPage.css";
import UnderlinedTextInput from "./underlinedText/UnderlinedTextInput";
import AuthService from "../../services/auth/AuthService";
import { useHistory } from "react-router-dom";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [emailInvalid, setEmailInvalid] = useState(false);
  const [passwordInvalid, setPasswordInvalid] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [invalidMessage, setInvalidMessage] = useState("");

  const history = useHistory();

  // state
  // eslint-disable-next-line no-unused-vars
  const [state, dispatch] = useContext(Context);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const checkEmail = () => {
    if (!(email && email.length > 1)) {
      return "Email is required.";
    } else {
      return false;
    }
  };

  const checkPassword = () => {
    if (!(password && password.length > 1)) {
      return "A password is required.";
    } else {
      return false;
    }
  };

  // add event listener so the user can just hit the enter key after typing
  // useEffect(() => {
  //   window.addEventListener("keydown", handleKeydown);

  //   return () => {
  //     window.removeEventListener("keydown", handleKeydown);
  //   };
  // }, []);

  // const handleKeydown = useCallback((e) => {
  //   if (e.key === "Enter") submit();
  // }, []);

  useEffect(() => {
    setEmailInvalid(false);
    setPasswordInvalid(false);
    setInvalidMessage("");
  }, [email, password]);

  // useEffect(() => {
  //   window.addEventListener("keydown", handleKeyDown);

  //   return () => {
  //     window.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, []);

  const submit = () => {
    if (checkEmail()) {
      setEmailInvalid(true);
      setInvalidMessage(checkEmail());
      return;
    }
    if (checkPassword()) {
      setPasswordInvalid(true);
      setInvalidMessage(checkPassword());
      return;
    }
    AuthService.login(email, password)
      .then((value) => {
        console.log(value);
        history.push({
          pathname: "/books",
        });
        dispatch({ type: "LOG_IN" });
      })
      .catch((e) => {
        setInvalidMessage("Email and password not found.");
        setEmailInvalid(true);
        setPasswordInvalid(true);
        console.log("error logging in: ", e);
      });
  };

  // // ENTER TO SUBMIT
  // const handleKeyDown = useCallback((e) => {
  //   if (e.key === "Enter") {
  //     submit();
  //     console.log("ENETER");
  //   }
  // }, []);

  return (
    <div className="login-page-container">
      <div className="login-modal">
        <div className="login-modal__title">Login</div>
        <div className="login-modal__content">
          <UnderlinedTextInput
            label={"Email"}
            value={email}
            onValueChange={handleEmailChange}
            placeholder="Enter your email here"
            isInvalid={emailInvalid}
            func={submit}
          />

          <UnderlinedTextInput
            label={"Password"}
            isInvalid={passwordInvalid}
            value={password}
            onValueChange={handlePasswordChange}
            type={"password"}
            placeholder="Enter your password here"
            func={submit}
          />

          {/* {invalidMessage && invalidMessage.length > 1 && (
            <div className="invalid-message-container">{invalidMessage}</div>
          )} */}
          <div className="submit-button-container">
            <button className="submit-button" onClick={submit}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
